import {Swiper, SwiperSlide} from 'swiper/react';
import React from "react";
import 'swiper/swiper.scss';
import styled from "styled-components";

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  justify-content: center;
  margin: -6px;
`;
const Item = styled.div`
  font-weight: 400;
  line-height: 1.42857;
  margin: 0px;
  flex-basis: 25%;
  -webkit-box-flex: 0;
  flex-grow: 0;
  max-width: 25%;
  padding: 6px;
`;

export default function ListProduct(props: any) {

    const renderItem = (item: any, index: number) => {
        return <Item key={index.toString()}>{props.renderItem(item)}</Item>
    }

    return (
        <Container>
            {
                props.data.map((item: any, index: number) => renderItem(item, index))
            }
        </Container>
    )
}
